<template>
    <zh-table-page
      ref="tableRef"
      v-bind="{
        title: '硬盘管理',
        search,
        api,
        afterGetDetail,
        beforeSave,
        ...table,
        ...dialog,
      }"
    >
    </zh-table-page>

  </template>
  <script>
  import {
    defineComponent,
    reactive,
    ref,
    toRefs,
    getCurrentInstance,
    onMounted,
    watch,
    computed,
  } from "vue";
  import { useRouter } from "vue-router";
  import { ElMessageBox } from "element-plus";
  import moment from "moment"
  export default defineComponent({
    setup() {
      const { proxy } = getCurrentInstance();
      const router = useRouter();
      const tableRef = ref();
      const state = reactive({
        search: [
          {
            label: "服务器名称",
            placeholder: "服务器名称",
            value: "serverName",
          },
          
        ],
        api: {
          list: "postHardDiskPage",
          delete: "",
          add: "postHardDiskSave",
          edit: "postHardDiskUpdate",
          detail: "",
          tree: "",
        },
        table: {
          columns: [
          { label: "服务器名称", prop: "serverName" },
            // { label: "硬盘名称", prop: "hardDiskName" },
            { label: "挂载目录", prop: "mountDirectory" },
            { label: "分区名称", prop: "partitionName" },
            { label: "硬盘大小", prop: "size",  scopeFun: (scope) => {
            if (scope.row.size) {
              return scope.row.size +'G';
            }
            return '--'

          }, },
           
          ],
          operations: [
            { label: "编辑" },
            // { label: "删除", type: "danger" },
          ],
          rowKey: "id",
        },
        dialog: {
          dialogForm: [
            {
              label: "硬盘名称",
              placeholder: "请输入硬盘名称",
              value: "hardDiskName",
            },
            {
              label: "挂载目录",
              placeholder: "请输入挂载目录",
              value: "mountDirectory",
            },
            {
              label: "分区名称",
              placeholder: "请输入分区名称",
              value: "partitionName",
            },
            {
              label: "硬盘大小",
              placeholder: "请输入硬盘大小",
              value: "size",
            },
            
            {
              component: "zh-select",
              label: "实体服务器",
              placeholder: "请选择实体服务器",
              value: "serverId",
              url:"postServerList",
              field: {
                id: "value",
                serverName: "label",
              },
              // params: {
              //   serverType: 2,
              // },
              
            },
          ],
          dialogRules: {
            serverId: [
              { required: true, message: "请选择服务器", trigger: "blur" },
            ],
         
           
          },
        },
      });
      onMounted(() => {
      });
      //点击编辑处理详情数据
      const afterGetDetail = (data) => {
        return {
          ...data,
        };
      };
      //新增编辑保存之前
      const beforeSave = (form)=>{
        return {
          ...form,
        }
      }

      return {
        ...toRefs(state),
        tableRef,
        afterGetDetail,
        beforeSave,
      };
    },
  });
  </script>
  